// extracted by mini-css-extract-plugin
export var menuIcon = "_qs-0";
export var menuIconInline = "_qs-1";